module.exports = __webpack_public_path__ + "img/1.a6401750.png";